import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './OnboardingTestFailed.module.css';
import TopNavBarNew from "../../Components/TopNavBarNew";
import BottomNavBarNew from "../../Components/BottomNavBarNew";

export default function OnboardingTestFailed({ appLanguage }) {
  const [pageState, setPageState] = useState({
    title: '',
    title2: '',
    extraText: '',
    extraText2: '',
    button1: '',
    button2: '',
    icon: '',
    illustration: '',
    selectedChoices: []
  });

  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Eligibility Test Failed";

    const entries = JSON.parse(localStorage.getItem("ayaAppEntries") || "[]");
    const assets = JSON.parse(localStorage.getItem("ayaAppAssets") || "[]");

    const getEntryById = (id) => entries.find((e) => e.sys.id === id);
    const getField = (entry, field, locale) =>
      entry?.fields?.[field]?.[locale] || entry?.fields?.[field]?.["en"] || "";

    const getAssetUrlById = (id, locale) => {
      const asset = assets.find((a) => a.sys.id === id);
      const file = asset?.fields?.file?.[locale] || Object.values(asset?.fields?.file || {})[0];
      if (!file?.url) return '';
      return file.url.startsWith('//') ? `https:${file.url}` : file.url;
    };

    const entry = getEntryById("7jIl7Gs7qaN0uBhy2y0wfo");

    const allSelected = JSON.parse(localStorage.getItem("userSelectedOptions") || "[]");
    const failChoices = allSelected
      .filter((choiceObj) => choiceObj.isLastOption !== true)
      .map((choiceObj) => choiceObj.optionText);

    setPageState((prevState) => ({
      ...prevState,
      title: getField(entry, "title", appLanguage),
      title2: getField(entry, "title2", appLanguage),
      extraText: getField(entry, "extraText", appLanguage),
      extraText2: getField(entry, "extraText2", appLanguage),
      button1: getField(entry, "button1", appLanguage),
      button2: getField(entry, "button2", appLanguage),
      icon: getAssetUrlById("509AEqxEJDlZ2wD4F7a2mt", appLanguage),
      illustration: getAssetUrlById("y3Rd7KceR170l23wC9ZX9", appLanguage),
      selectedChoices: failChoices,
    }));
  }, [appLanguage]);

  return (
    <>
    
      <TopNavBarNew backgroundColor="#fff" breadcrumbColor="#333" />
      <div className={styles.pageContainer}>
      {/* Title */}
      <div className={styles.title}>{pageState.title}</div>

      {/* Icon */}
      <img src={pageState.icon} alt="Warning Icon" className={styles.icon} />

      {/* Title2 */}
      <div className={styles.title2}>{pageState.title2}</div>

      {/* Selected Choices Box */}
      <div className={styles.choicesBox}>
        <div className={styles.extraText}>{pageState.extraText}</div>
        <div className={styles.choicesList}>
          {pageState.selectedChoices.map((choice, index) => (
            <div key={index} className={styles.choiceCard}>
              <div className={styles.choiceText}>{choice}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Illustration */}
      <img
        src={pageState.illustration}
        alt="Illustration"
        className={styles.illustration}
      />

      {/* Extra Text2 */}
      <div className={styles.extraText2}>{pageState.extraText2}</div>

      {/* Buttons */}
      <button
        className={styles.button1}
        onClick={() => history.push('/chat-main')}
      >
        {pageState.button1}
      </button>
      <button
        className={styles.button2}
        onClick={() => history.push('/home')}
      >
        {pageState.button2}
      </button>

      <div className={styles.extraSpaceTop}></div>
      <BottomNavBarNew appLanguage={appLanguage}/>
    </div>
    </>
  );
}